import styled, {css} from "styled-components";

export const StyledButton = styled.button`
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: ${({$gap}) => ($gap ? $gap : "5px")};
    padding: 13px 15px;
    border-radius: 60px;
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    width: ${({$width}) => ($width ? $width : "172px")};
    min-width: ${({$width}) => ($width ? $width : "172px")};
    background: ${({theme}) => theme?.light?.primary};
    color: #242424;
    transition: 0.5s all ease-in-out;
    /* box-shadow: 0px 4px 3px 0px #FFFFFF45 inset, 0px -3px 5px 0px #FFFFFF40 inset; */
    overflow: hidden;
    @media (min-width: 768px) {
        font-size: 16px;
        line-height: 20px;
    }

    ${({$loader, disabled}) =>
        $loader ||
        (disabled &&
            css`
                cursor: not-allowed;
            `)}

    ${({$lg}) =>
        $lg &&
        css`
            width: ${({$width}) => ($width ? $width : "300px")};
            padding: 15px;
        `}
  ${({$sm}) =>
        $sm &&
        css`
            width: auto;
            min-width: auto;
            padding: 6px 28px;
        `}

  @media screen and (max-width:786px) {
        padding: 8px 15px;
    }
    /***** Background-Variants-Start *****/
    ${({$variant}) =>
        $variant == "white" &&
        css`
            background: var(--white);
            color: var(--blue);
            box-shadow: 0px 3px 10px 0px #0000001a;
            padding: 14px 34px;
        `}
    ${({$variant}) =>
        $variant === "cancel" &&
        css`
            background: var(--danger);
            color: var(--white);
        `}
    ${({$variant}) =>
        $variant === "preparing" &&
        css`
            background: rgba(44, 185, 255, 1);
            color: var(--white);
        `}
    ${({$variant}) =>
        $variant === "ready" &&
        css`
            background: rgba(39, 196, 83, 1);
            color: var(--white);
        `}
    ${({$variant}) =>
        $variant === "delivery" &&
        css`
            background: rgba(94, 64, 153, 1);
            color: var(--white);
        `}
    ${({$variant}) =>
        $variant === "out_for_delivery" &&
        css`
            background: rgba(245, 126, 42, 1);
            color: var(--white);
        `}
    ${({$variant}) =>
        $variant === "accepted" &&
        css`
            background: rgb(232, 23, 23);
            color: var(--white);
        `}
    ${({$variant}) =>
        $variant === "completed" &&
        css`
            background: var(--white);
            border: 1px solid rgba(236, 236, 236, 1);
            color: var(--text-color);
        `}
    ${({$variant}) =>
        $variant === "transparent" &&
        css`
            background: transparent;
            border: none;
            color: rgba(143, 143, 143, 1);
        `}
    ${({$variant}) =>
        $variant === "secondary" &&
        css`
            background: rgba(236, 236, 236, 1);
            color: rgba(143, 143, 143, 1);
        `}

  /*****************Background Variants End*********************/


  /*****************Border Variants Start*********************/

  ${({$outline}) =>
        $outline &&
        css`
            border: 1px solid var(--gray);
            background: transparent;
            color: var(--gray);
        `}

  ${({$danger}) =>
        $danger &&
        css`
            border: 1px solid var(--danger);
            background: transparent;
            color: var(--danger);

            &:hover {
                background: var(--danger);
                color: var(--white);
            }
        `}

  ${({$gray}) =>
        $gray &&
        css`
            background: rgba(233, 233, 233, 1);
            color: rgba(143, 143, 143, 1);

            /* &:hover {
                background: ${({theme}) => theme?.light?.primary};
            } */
        `}
  /*****************Border Variants End*********************/

    .loader {
        width: 17px;
        height: 17px;
        border-radius: 50%;
        display: inline-block;
        border-top: 3px solid #fff;
        border-right: 3px solid transparent;
        box-sizing: border-box;
        animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    &::before {
        position: absolute;
        content: "";
        width: 70px;
        height: 300px;
        background: rgba(255, 255, 255, 0.7);
        transform: rotate(-35deg);
        top: -100px;
        left: -100%;
        transition: all 1500ms cubic-bezier(0.19, 1, 0.22, 1);
        opacity: 0;
    }
    &:hover {
        box-shadow: 0px 4px 3px 0px #ffffff45 inset, 0px -3px 5px 0px #ffffff40 inset;

        box-shadow: 0px 1px 14px 0px #1fabd300;
        &:before {
            left: 150%;
            opacity: 0.4;
        }
    }
`;
